export default "__VITE_ASSET__27BLg$aP__"